document.querySelectorAll('[data-collection-hero-bio]').forEach((wrapper) => {
  const trigger = wrapper.querySelector('.collection-hero__bio-trigger');
  const content = wrapper.querySelector('.collection-hero__description');
  if (!trigger || !content) return;

  trigger.addEventListener('click', () => {
    const isHidden = content.hasAttribute('hidden');

    if (isHidden) {
      content.removeAttribute('hidden');
      trigger.setAttribute('aria-expanded', 'true');
      wrapper.classList.add('is-open');
    } else {
      content.setAttribute('hidden', '');
      trigger.setAttribute('aria-expanded', 'false');
      wrapper.classList.remove('is-open');
    }
  });
});